<template>
  <div class="footer col-block width-full">
    <div class="footer-container col-block width-full">
      <div :style="{ height: isMobile ? '20px' : '75px' }"></div>
      <div class="footer-main-container" :class="[isMobile ? 'col-block width-full' : 'row-block flex-start']">
        <div class="footer-info-container col-block" :class="[isMobile ? 'width-full' : 'flex-start']">
          <div class="footer-info-logo-container center-block">
            <img :src="require('../../assets/images/main-text-logo.svg')" alt="" :style="{ 'max-width': '138.5px' }">
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="footer-info-data-container col-block flex-start">
            <div class="footer-info-data-block row-block flex-start" v-for="(infoData, idindex) in infoDatas" :key="idindex">
              <div class="footer-info-data-title break-line">{{ infoData.title }}</div>
              <div class="footer-info-data-content-container shrink col-block flex-start">
                <div class="footer-info-data-content break-line" v-for="(infoContent, icindex) in infoData.contents" :key="icindex">{{ infoContent }}</div>
              </div>
            </div>
          </div>
        </div>
        <div :style="isMobile ? { height: '50px' } : { width: '20px' }"></div>
        <div class="footer-form-container col-block">
          <div class="footer-form-title-container row-block">
            <div class="footer-form-title">{{ 'お問い合わせフォーム'/* ___ */ }}</div>
          </div>
          <div class="footer-form-main-container col-block width-full" :style="{ width: isMobile ? '100%' : '530px' }">
            <customForm
              :layoutType="'grid'"
              :formType="isMobile ? 'col' : 'row'"
              :groupCount="1"
              :init="data"
              :alerts="alerts"
              :forms="formOptions['field1']"
              @change="(result, validate, errors, _, type) => { formOnChange('field1', result, validate, errors, type) }"
            ></customForm>
          </div>
          <div class="footer-form-button-container row-block">
            <button class="main-button2 circle-button padding-button" :style="{ '--padding': '30px' }" :class="{ loading: onSubmit }" :disabled="onError" @click="e => !onSubmit ? validateSendContact() : ''">
              <span>{{ '送信する'/* ___ */ }}</span>
            </button>
          </div>
        </div>
      </div>
      <div :style="{ height: isMobile ? '45px' : '20px' }"></div>
      <div class="footer-copyright-container col-block">
        <div class="footer-copyright">{{ copyrightData.text }}</div>
      </div>
      <div :style="{ height: '25px' }"></div>
    </div>
  </div>
</template>

<script>
import { postSendContact } from '../../api'
import customForm from '../tool/customForm.vue'
import toastMethods from '../../mixins/toastMethods.vue'
import responsitive from '../../mixins/responsitive.vue'

export default {
  components: {
    customForm
  },
  mixins: [
    toastMethods,
    responsitive
  ],
  data () {
    return {
      data: {},
      users: [],
      result: {},
      display: {},
      alerts: {},
      validate: {},
      error: {},
      onSubmit: false
    }
  },
  computed: {
    onError () {
      return Object.values(this.alerts).filter(alert => alert && alert.type === 'error').length || Object.entries(this.error).some(([field, error]) => error.items.filter(item => this.formOptions[field].map(form => form.value).includes(item.field)).length)
    },
    // static
    formOptions () {
      return {
        'field1': [
          {
            title: 'お名前'/* ___ */,
            value: 'name',
            type: 'input',
            grid: 1,
            inputScale: '66.66%',
            placeholder: () => '例) 佐藤 太郎'/* ___ */,
            validate: 'required'
          },
          {
            title: '部署'/* ___ */,
            value: 'institution',
            type: 'input',
            grid: 1,
            placeholder: () => '例) 康百事総合病院'/* ___ */,
            validate: 'required'
          },
          {
            title: 'メールアドレス'/* ___ */,
            value: 'email',
            type: 'input',
            grid: 1,
            placeholder: () => '例) service@compassbioinfo.com'/* ___ */,
            validate: 'required'
          },
          {
            title: 'メッセージ'/* ___ */,
            value: 'message',
            type: 'textarea',
            grid: 1,
            row: 4,
            placeholder: () => '例) ご質問など'/* ___ */,
            validate: 'required'
          }
        ]
      }
    },
    infoDatas () {
      return [
        {
          title: '米国　　'/* ___ */,
          contents: [
            '445 Rocky River Rd, West Lake Hills, TX 78746'
          ]
        },
        {
          title: '台湾　　'/* ___ */,
          contents: [
            '新竹市東區慈雲路118號17樓之10 '
          ]
        },
        {
          title: '日本　　'/* ___ */,
          contents: [
            '東京都港区西新橋一丁目6番12号アイオス虎ノ門'
          ]
        },
        {
          title: '電話　　'/* ___ */,
          contents: [
            '+886 3-5745009',
            '(中国語、英語、日本語で対応可能)'
          ]
        },
        {
          title: 'メール\nアドレス'/* ___ */,
          contents: [
            'service@compassbioinfo.com'
          ]
        }
      ]
    },
    copyrightData () {
      return {
        text: 'Copyright © ' + (new Date()).getFullYear() + ' All Rights Reserved'/* ___ */
      }
    }
  },
  methods: {
    async formOnChange (field, result, validate, errors, type) {
      this.$set(this.error, field, errors)
      this.$set(this.validate, field, validate)
      this.result = {
        ...this.result,
        ...result
      }
    },
    customValidate (cols, rcols = []) {
      const validates = {
      }
      for (let col of cols || Object.keys(this.data)) {
        let alert = (validates[col] || (() => {}))(this.result[col])
        this.alerts = {
          ...this.alerts,
          [col]: alert || null
        }
      }
      this.alerts = {
        ...this.alerts,
        ...rcols.reduce((s, c) => ({ ...s, [c]: null }), {})
      }
      return !Object.values(this.alerts).filter(x => x).length
    },
    async validateSendContact () {
      let result = {}
      this.onSubmit = true
      for (let kv of Object.entries(this.validate)) {
        result[kv[0]] = await kv[1].validate()
      }
      result['custom'] = this.customValidate()
      if (!Object.values(result).includes(false)) {
        await this.sendContact()
      }
      this.onSubmit = false
    },
    async sendContact () {
      try {
        let config = {}
        let data = {
          ...this.result
        }
        let response = await postSendContact(data, config)
        this.addToast('success', response.data.result.message)
        this.data = {}
        for (let kv of Object.entries(this.validate)) {
          kv[1].reset()
        }
      } catch (error) {
        this.addToast('error', !error.response ? error.message : error.response.data.result.message)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/footer.vue